module.exports = __webpack_public_path__ + "static/media/Handheld3.3b3539a1.jpeg";